/* eslint-disable */
//todo удалить когда вернемся к авторизации
export interface ValidateResult {
  result?: boolean
}

export interface UserData {
  full_name: {
    first_name: string
    last_name?: string
    middle_name?: string
  }
  is_fully_ident: boolean
  phone_number: string
  wallet_id: string
  organizations?: []
  ibso_id?: string
  rbo_id?: string
  hid?: string
  r2_id?: string
}

export interface AuthData {
  user_id: string
  client_id: string
  expiry: Date
  duration: number
  device_id: string
  user_data: UserData
}

export enum AuthType {
  ANONYMOUS = 1,
  SIMPLE_IDENTIFIED = 2,
  FULL_IDENTIFIED = 3,
  BANK_CLIENT = 4,
}

export enum ProfileType {
  // "profile:type" (для старых версий профиля):
  'default' = 'na',
  'Мобильная связь' = 'real',
  'Фиксированная связь и СТВ' = 'real',
  'Фиксированная связь' = 'real',
  'Безопасное детство' = 'real',
  'Виртуальный номер' = 'virt',
  'МТС Коннект' = 'virt',
  'Госуслуги' = 'other',
  'mgts' = 'other',
  'mrmsk' = 'other',
  'mgts, mrmsk' = 'other',
  'Домашний интернет' = 'other',
}

// type для новых типов профилей
export enum NewProfileType {
  'MOBILE' = 'mobile',
  'FIX' = 'fix',
  'LBSV' = 'lbsv',
  'VIRTUAL' = 'virtual',
  'GS' = 'gs',
  'mgts' = 'mgts',
  'mrmsk' = 'mrmsk',
  'mgts, mrmsk' = 'mgts, mrmsk',
  'IOT' = 'iot',
}

export enum AccountType {
  'Мобильная связь' = 'mobile',
  'Фиксированная связь и СТВ' = 'stv',
  'Фиксированная связь' = 'fix',
  'Виртуальный номер' = 'mobile',
  'МТС Коннект' = 'mobile',
  'Безопасное детство' = 'mobile',
  'Госуслуги' = 'other_operators',
  'mgts' = 'mgts',
  'mrmsk' = 'mgts',
  'mgts, mrmsk' = 'mgts',
  'Домашний интернет' = 'fix',
}

// export interface UserProfile extends Dictionary<string | AuthType> { //todo Dictionary redux
//   mobilePhone?: string
//   authType?: AuthType
//   userId?: string
// }

export interface Headers {
  Authorization?: string
}

export enum UUID {
  TID = 'tid',
  STATE = 'state',
}

export enum LocalStorageKey {
  ACCESS_TOKEN = 'access_token',
  BACK_TO_URL = 'backToURL',
}

export interface MtsData {
  exp: number
  jti: string
  iat: number
  iss: string
  sub: string
  globallyUniqueIdentifier: string
  at_hash: string
  azp: string
  nonce: string
  phone: string
  realm: string
  tokenName: string
  tokenType: string
  client_id: string
  scope_list: string[]
  auth_time: number
  country: string
  description: string
  aud: string
  type: string
  c_hash: string
}

export type SetMtsDataStore = (mtsData: MtsData) => void

export enum AuthorizationState {
  INIT = 'init',
  IN_PROGRESS = 'inProgress',
  REJECT = 'reject',
  ERROR = 'error',
}
